import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {finalize, Subscription} from 'rxjs';
import {AgGridAngular} from 'ag-grid-angular';
import { SharedService } from 'src/app/services/shared.service';
import {CodemirrorComponent} from '@ctrl/ngx-codemirror';
import {ToastService} from '../../../services/toast.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { StorageService } from 'src/app/services/storage.service';
import { GridService } from 'src/app/services/grid.service';
import {MatDialogRef} from '@angular/material/dialog';
import {ProgressBarsService} from '../../../services/progress-bars.service';
import {MatStepper} from '@angular/material/stepper';
import { AuthService } from 'src/app/services/auth.service';
import {
  logExperimentalWarnings
} from '@angular-devkit/build-angular/src/builders/browser-esbuild/experimental-warnings';
import { InfoService } from 'src/app/services/info.service';

@Component({
  selector: 'app-import-diaglog',
  templateUrl: './import-diaglog.component.html',
  styleUrls: ['./import-diaglog.component.scss']
})
export class ImportDiaglogComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('stepper') private stepper: MatStepper | undefined;

  private file: File | undefined;
  private fileStructure: any = null;
  private fileServerPath: string = '';
  public fileName: string = '';
  public initFormReady: boolean = false;
  public initFormNextButtonDisabled: boolean = true;
  // True while parseFile is analyzing the uploaded file server-side — drives
  // the progress indicator on the upload step so large files don't look stuck.
  public analyzingFile: boolean = false;
  // Opt-in: run the full Update & Sync chain automatically when the import
  // completes. Defaults to off; uses the user's preferred sync mode.
  public autoSyncAfterImport: boolean = false;
  // Upload percentage (null = no upload in flight)
  public uploadProgress: number | null = null;
  // Server-side analysis progress streamed over websocket
  public analysisProgress: any = null;

  public tables: any[] = [];
  public brands: any[] = [];
  public gridRows: any[] = [];

  public tagsUpdateMethod = [
    {
      value: 'replace',
      viewValue: 'Replace'
    },
    {
      value: 'append',
      viewValue: 'Append'
    },
    {
      value: 'remove',
      viewValue: 'Remove'
    }
  ];

  public tagsUpdateMethodForm: FormGroup = new FormGroup({
    method: new FormControl({
      value: null,
      disabled: false
    }, Validators.required)
  });

  public selectedTagsUpdateMethod: any = [];

  public tableHeaders: any[] = [];
  public disableNextStep = false;

  public updateFormAssociationsFields: any = [];
  public createFormAssociationsFields: any = [];

  private updateAssociateData: any = [];
  private createAssociateData: any = [];

  public update: boolean = true;
  public create: boolean = true;
  public findProductsUpdates = 0;
  public findProductsCreates = 0;

  public selectedStep: string = 'upload';

  public initForm: FormGroup = new FormGroup({
    table: new FormControl({
      value: null,
      disabled: false
    }, Validators.required)
  });

  public updateForm: FormGroup = new FormGroup({
    table: new FormControl(null),
    brand: new FormControl(null),
    skuField: new FormControl(null),
    tagsMethodUpdate: new FormControl(null),
  });

  public createForm: FormGroup = new FormGroup({
    table: new FormControl(null),
    brand: new FormControl(null),
    skuField: new FormControl(null)
  });

  public importUpdateProgressBar: number = 0;
  public importCreateProgressBar: number = 0;
  public lockUpdateButton: boolean = false;
  // "Skip creating new parts" option for mixed update+create files — sent to
  // newUpdateProducts so unmatched rows are not auto-created during the update.
  public skipCreation: boolean = false;
  public lockCreateButton: boolean = false;
  public rows: any[] = ["sku","shopify_published", "mws_shopify_published", "vendor_tags", "obsolete",'add_tags',"handle","amazon_published","replacement", "replacement_sku","brand_id","type_id","description","list_price","product_tags","brand","type","cost_price","sell_price","mws_sell_price", "pack_qty","image","datasheet","installation_instructions","url_manufacturer","body_seo","google_category","weight_lbs","title_prefix_1","title_prefix_2","title_prefix_3","title_suffix_1","title_suffix_2","title_suffix_3","body_prefix_1","body_prefix_2","body_prefix_3","body_suffix_1","body_suffix_2","body_suffix_3"];

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private storageService: StorageService,
    private gridService: GridService,
    private dialogRef: MatDialogRef<ImportDiaglogComponent>,
    private progressBarsService: ProgressBarsService,
    private authService: AuthService,
    private infoService: InfoService
  ) {

  }
  ngOnDestroy() {
    this.infoService.productionImportUpdateComplete.next(false);
    this.infoService.productionImportCreateComplete.next(false);
  }
  ngOnInit(): void {
    this.brands = this.storageService.brands;
    this.infoService.productionImportUpdateComplete.subscribe(res => {
      if (res) {
        this.importUpdateProgressBar = 0;
        const totalSteps: any = this.stepper?.steps.length;
        if (totalSteps - 1 === this.stepper?.selectedIndex) {
          setTimeout(() => {
            this.close();
          }, 600);
        } else {
          this.stepper?.next();
        }
      }
    });

    this.infoService.productionImportCreateComplete.subscribe(res => {
      if (res) {
        this.importCreateProgressBar = 0;
        this.close();
      }
    });

    this.sharedService.columnDefs.forEach((row: any) => {
      if (!['_id', 'title_ai', 'collections', 'status', 'asm_origin_zip', 'confirm', 'product_id', 'changed_by', 'pushed_user', 'user_id', 'user_name', 'updated_at', 'pushed_at', 'replacement.obsolete', 'mws_shopify_id', 'shopify_id'].includes(row.field)) {
        if (row.field === 'body_seo') {
          this.gridRows.push({
            value: 'body',
            viewValue: 'Body'
          });
        } else if (row.field === 'datasheet_new') {
          this.gridRows.push({
            value: 'datasheet_new',
            viewValue: 'Datasheet'
          });
        } else if (row.field === 'shopify_published') {
          this.gridRows.push({
            value: 'bhs_shopify_published',
            viewValue: 'BHS Shopify Published'
          });
        } else if (row.field === 'sell_price') {
          this.gridRows.push({
            value: 'bhs_sell_price',
            viewValue: 'BHS Sell Price'
          });
        } else {
          this.gridRows.push({
            value: row.field,
            viewValue: row.headerName
          });
        }
      }
    });

    this.progressBarsService.importUpdateBar.subscribe(res => { this.importUpdateProgressBar = res; });
    this.progressBarsService.importCreateBar.subscribe(res => { this.importCreateProgressBar = res; });
    this.progressBarsService.importAnalysis.subscribe(res => { this.analysisProgress = res; });
  }

  private checkExistProductId(sheets: any): boolean {
    let exist = false;
    for (const sheet of sheets) {
      if (sheet.headers.map((h: any) => h.value).includes('product_id')) {
        exist = true;
      }
    }

    if (!exist) {
      this.toastService.error('This document does not contain the "product_id" field.');
    }

    return exist;
  }

  public uploadFile(event: any): void {
    this.file = event.target.files[0];

    if (this.file) {
      const formData = new FormData();
      formData.append("file", this.file);
      this.fileName = this.file.name;

      // Large files (hundreds of MB) upload for minutes — show a real
      // percentage instead of a dead dialog.
      this.uploadProgress = 0;
      this.http.post(environment.API_PATH + '/import/uploadFile', formData, {
        reportProgress: true,
        observe: 'events'
      }).subscribe({
        next: (httpEvent: any) => {
        if (httpEvent.type === HttpEventType.UploadProgress && httpEvent.total) {
          this.uploadProgress = Math.round((httpEvent.loaded / httpEvent.total) * 100);
          return;
        }
        if (httpEvent.type !== HttpEventType.Response) {
          return;
        }
        this.uploadProgress = null;
        const res: any = httpEvent.body;
        if (res.error) {
          this.toastService.info(res.error, '', {timeOut: 0});
        } else if (this.checkExistProductId(res.result)) {
          if (res.message) {
            this.toastService.error(res.message);
          } else {
            this.fileStructure = res.result;
            this.fileServerPath = res.file;
            this.tables = this.fileStructure.map((table: any) => {
              return {
                index: table.index,
                value: table.value,
                viewValue: table.viewValue
              }
            });
            this.findProductsUpdates = 0;
            this.findProductsCreates = 0;

            this.initFormReady = true;

            if (this.fileStructure.length === 1) {
              this.initForm.get('table')?.setValue(this.tables[0].value);
              this.onTableChange(this.fileStructure[0]);
              this.initForm.get('table')?.enable();

              console.log('uploadFile', res);
            }
          }
        }
        },
        error: () => {
          this.uploadProgress = null;
          this.toastService.error('File upload failed. Please try again.');
        }
      });
    }
  }


  public onTableChange(event: any): void {
    this.tableHeaders = structuredClone(this.fileStructure.find((s: any) => s.value === event.value)?.headers);
    this.updateForm = this.fb.group({});
    this.createForm = this.fb.group({});

    console.log('this.fileStructure', this.fileStructure);
    this.fileStructure.find((s: any) => s.value === event.value)?.headers.forEach((item: any) => {
      if (!['product_id'].includes(item.value)) {
        this.updateForm.addControl(item.value, new FormControl({
          value: null,
          disabled: false
        }, Validators.required));
        this.createForm.addControl(item.value, new FormControl({
          value: null,
          disabled: false
        }, Validators.required));
      }
    });

    this.updateAssociateData = [];
    this.createAssociateData = [];
    this.createFormAssociationsFields = structuredClone(
      this.fileStructure.find((s: any) => s.value === event.value)?.headers
        .filter((item: any) => item.value !== 'product_id')
    );

    this.updateFormAssociationsFields = structuredClone(
      this.fileStructure.find((s: any) => s.value === event.value)?.headers
        .filter((item: any) => item.value !== 'product_id')
    );
    this.checkFile();
    setTimeout(() => {
      console.log('---', this.createForm.controls);
    }, 7000);
  }

  public onBrandChange(event: any): void {
    this.checkFile();
  }

  public onIdentityFieldChange(event: any): void {
    this.updateForm.reset();
    this.createForm.reset();
    this.refreshCreateForm();
    this.refreshUpdateForm();

    this.updateForm.removeControl(event.value);
    this.createForm.removeControl(event.value);

    this.updateFormAssociationsFields = this.fileStructure
      .find((s: any) => s.value === this.initForm.get('table')?.value)?.headers
      .filter((item: any) => item.value !== event.value);

    this.createFormAssociationsFields = this.fileStructure
      .find((s: any) => s.value === this.initForm.get('table')?.value)?.headers
      .filter((item: any) => item.value !== event.value);

    this.checkFile();
  }

  public refreshUpdateForm(): void {
    this.updateFormAssociationsFields = this.fileStructure
      .find((s: any) => s.value === this.initForm.get('table')?.value)?.headers
      .filter((item: any) => item.value !== this.initForm.get('skuField')?.value);

    this.updateFormAssociationsFields.forEach((item: any) => {
      if (this.updateForm.get(item.value) === null && item.value !== this.initForm.get('skuField')?.value) {
        this.updateForm.addControl(item.value, new FormControl({
          value: null,
          disabled: false
        }, Validators.required));
      }
    });
  }

  public refreshCreateForm(): void {
    this.createFormAssociationsFields = this.fileStructure
      .find((s: any) => s.value === this.initForm.get('table')?.value)?.headers
      .filter((item: any) => item.value !== this.initForm.get('skuField')?.value);

    this.createFormAssociationsFields.forEach((item: any) => {
      if (this.createForm.get(item.value) === null && item.value !== this.initForm.get('skuField')?.value) {
        this.createForm.addControl(item.value, new FormControl('', Validators.required));
      }
    });
  }

  public onUpdateAssociate(item: any, event: any): void {
    console.log('onUpdateAssociate', item, event);
    const data = {
      documentField: item.value,
      tableField: event ? event.value || event : null
    }

    const existRecord = this.updateAssociateData.findIndex((x: any) => x.documentField === data.documentField);
    if (existRecord === -1) {
      this.updateAssociateData.push(data);
    } else {
      this.updateAssociateData[existRecord] = data;
    }
    this.onCreateAssociate(item, event);
    this.createForm.get(item.value)?.setValue(event ? event.value || event : null);
    console.log('updateAssociateData', this.updateAssociateData);
  }

  autoFieldsFill() {
    for (const field of this.createFormAssociationsFields) {
      let fItem = this.gridRows.find((x: any) => x.value === field.value);
      if (field.value === 'datasheet') {
        fItem = this.gridRows.find((x: any) => x.value === 'datasheet_new');
      }

      if (fItem && fItem.value === 'datasheet_new') {
        if (this.findProductsCreates) {
          this.onCreateAssociate(field, {value: fItem.value});
          this.createForm.get('datasheet')?.setValue(fItem ? fItem.value || fItem : null);
        }

        if (this.findProductsUpdates) {
          this.onUpdateAssociate(field, {value: fItem.value});
          this.updateForm.get('datasheet')?.setValue(fItem ? fItem.value || fItem : null);
        }
      } else {
        if (fItem) {
          if (this.findProductsCreates) {
            this.onCreateAssociate(field, {value: fItem.value});
            this.createForm.get(fItem.value)?.setValue(fItem ? fItem.value || fItem : null);
          }

          if (this.findProductsUpdates) {
            this.onUpdateAssociate(field, {value: fItem.value});
            this.updateForm.get(fItem.value)?.setValue(fItem ? fItem.value || fItem : null);
          }
        }
      }
    }
  }
  public onCreateAssociate(item: any, event: any): void {
    const data = {
      documentField: item.value,
      tableField: event ? event.value || event : null
    }

    const existRecord = this.createAssociateData.findIndex((x: any) => x.documentField === data.documentField);
    if (existRecord === -1) {
      this.createAssociateData.push(data);
    } else {
      this.createAssociateData[existRecord] = data;
    }
  }

  public deleteRowFromUpdateFields(i: number, value?: any) {
    console.log('deleteRowFromUpdateFields', value, i);
    // this.updateFormAssociationsFields.splice(i, 1);
    if (this.updateAssociateData.length) {
      const index = this.updateAssociateData.findIndex((x: any) => x.documentField === value.value);
      if (index !== -1) {
        this.updateAssociateData.splice(index, 1);
      }
    }
    console.log('this.updateAssociateData', this.updateAssociateData);
    // this.updateForm.removeControl(value.value);
  }

  public deleteRowFromCreateFields(i: number, value?: any): void {
    // this.createFormAssociationsFields.splice(i, 1);
    if (this.createAssociateData.length) {
      const index = this.createAssociateData.findIndex((x: any) => x.documentField === value.value);
      if (index !== -1) {
        this.createAssociateData.splice(index, 1);
      }
    }
    // this.createForm.removeControl(value.value);
  }

  onStepChange(event: any): void {
    this.selectedStep = event.selectedStep.label;
    console.log('event', event);

    if (this.selectedStep === 'Create Products') {
      this.disableNextStep = true
    } else {
      this.disableNextStep = false;
    }
  }

  skipUpdate(): void {
    this.stepper?.next();
    this.stepper?.next();
  }

  nextStep(): void {
    this.stepper?.next();
    setTimeout(() => {
      this.autoFieldsFill();
    }, 500);
  }

  onCheckBox(event: any, item: any, index: number, form: string): void {
    if (event.checked) {
      if (form === 'updateForm') {
        this.updateForm.get(item.value)?.enable();
        this.createForm.get(item.value)?.enable();
        this.onUpdateAssociate(item, this.createForm.get(item.value)?.value);
        this.onCreateAssociate(item, this.createForm.get(item.value)?.value);
      } else if (form === 'createForm') {
        this.createForm.get(item.value)?.enable();
        this.onCreateAssociate(item, this.createForm.get(item.value)?.value);
      }
    } else {
      if (form === 'updateForm') {
        this.updateForm.get(item.value)?.disable();
        this.createForm.get(item.value)?.disable();
        this.deleteRowFromUpdateFields(index, item);
        this.deleteRowFromCreateFields(index, item);
      } else if (form === 'createForm') {
        this.createForm.get(item.value)?.disable();
        this.deleteRowFromCreateFields(index, item);
      }
    }
  }

  test() {
    this.gridService.gridApi?.setFilterModel(null);
    this.gridService.gridApi?.setFilterModel({
      shopify_sync_status: {
        filterType: 'text',
        type: 'contains',
        filter: 3
      }
    });

    this.gridService.gridApi?.refreshServerSideStore({purge: true})
  }

  newUpdateProducts(): void {
    this.lockUpdateButton = true;
    this.importUpdateProgressBar = 1;
    setTimeout(() => {
      const uploadData = {
        filePath: this.fileServerPath,
        selectedTable: this.initForm.get('table')?.value,
        associateData: this.updateAssociateData,
        count: this.findProductsUpdates,
        skipCreation: this.skipCreation,
        autoSync: this.autoSyncAfterImport,
        syncMode: localStorage.getItem('syncModePreference') || 'bulk'
      }
      this.progressBarsService.setBulkValue(1);
      this.http.post(environment.API_PATH + '/import/newUpdateProducts', uploadData).subscribe((res: any) => {});
    }, 30);
  }

  updateProducts(): void {
    this.lockUpdateButton = true;
    this.importUpdateProgressBar = 1;
    setTimeout(() => {
      const uploadData = {
        filePath: this.fileServerPath,
        selectedTable: this.initForm.get('table')?.value,
        associateData: this.updateAssociateData,
        count: this.findProductsUpdates
      }
      this.progressBarsService.setBulkValue(1);
      this.http.post(environment.API_PATH + '/import/updateProducts', uploadData).subscribe((res: any) => {
      });
    }, 100);
  }

  createProducts(): void {
    this.lockCreateButton = true;
    this.importCreateProgressBar = 1;
    setTimeout(() => {
      this.createAssociateData.push({
        documentField: 'brand',
        tableField: 'brand'
      });
      const uploadData = {
        filePath: this.fileServerPath,
        selectedTable: this.initForm.get('table')?.value,
        associateData: this.createAssociateData,
        count: this.findProductsCreates
      }
      this.progressBarsService.setBulkValue(1);
      // console.log('-------', uploadData, this.fileStructure);
      this.http.post(environment.API_PATH + '/import/createProducts', uploadData).subscribe((res: any) => {
        console.log('createProducts', res);
      });
    }, 100);
  }

  checkFile(): void {
    console.log('this.initForm.valid', this.initForm.valid);
    if (this.initForm.valid && this.file) {
      const uploadData = {
        filePath: this.fileServerPath,
        selectedTable: this.initForm.get('table')?.value,
        brand_id: this.initForm.get('brand')?.value,
        // identityField: this.initForm.get('skuField')?.value
      }

      // console.log('uploadData', uploadData);

      this.analyzingFile = true;
      this.initFormNextButtonDisabled = true;
      this.http.post(environment.API_PATH + '/import/parseFile', uploadData).subscribe({
        next: (res: any) => {
          this.analyzingFile = false;
          if (res.message) {
            this.initFormNextButtonDisabled = true;
            this.toastService.error(res.message);
          } else {
            this.initFormNextButtonDisabled = false;
            console.log('parseFile', res);

            this.findProductsUpdates = res.updateCounter;
            this.findProductsCreates = res.createCounter;

            this.update = res.updateCounter > 0;
            this.create = res.createCounter > 0;
          }
        },
        error: () => {
          this.analyzingFile = false;
          this.toastService.error('File analysis failed. Please try again.');
        }
      });
    } else {
      // this.initForm.markAllAsTouched();
      // this.toastService.error('Please fill all fields', 'Import Data');
    }
  }

  toggleUpdateState = 1;
  public toggleUpdate() {
    if (this.toggleUpdateState === 0) {
      Object.keys(this.updateForm.controls).forEach(key => {
        this.updateForm.get(key)?.enable();
        console.log('key', key);
        this.onUpdateAssociate(key, key);
      });
      this.toggleUpdateState = 1;
    } else {
      Object.keys(this.updateForm.controls).forEach(key => {
        this.updateForm.get(key)?.disable();
      });
      this.updateAssociateData = [];
      this.toggleUpdateState = 0;
    }
  }

  public deselectUpdate() {
    Object.keys(this.updateForm.controls).forEach(key => {
      this.updateForm.get(key)?.disable();
    });
    this.updateAssociateData = [];
  }

  toggleCreateState = 1;
  public toggleCreate() {
    if (this.toggleCreateState === 0) {
      Object.keys(this.createForm.controls).forEach(key => {
        this.createForm.get(key)?.enable();
      });
      this.toggleCreateState = 1;
    } else {
      Object.keys(this.createForm.controls).forEach(key => {
        this.createForm.get(key)?.disable();
      });
      this.toggleCreateState = 0;
    }
  }
  public deselectCreate() {
    Object.keys(this.createForm.controls).forEach(key => {
      this.createForm.get(key)?.disable();
    });
    this.createAssociateData = [];
  }

  close() {
    if (this.fileServerPath) {
      this.http.post(environment.API_PATH + '/import/close', {
        filePath: this.fileServerPath
      }).subscribe(res => {});
    }
    this.dialogRef.close();
  }
}
